import { delay } from "./registry";
import type { AuditListFilter, AuditLogEntry } from "../../types/audit";
import type { PageResponse } from "../../types/patient";

const ROWS: AuditLogEntry[] = [
  {
    id: "a-1",
    occurredAt: new Date().toISOString(),
    actorType: "USER",
    actorId: "00000000-0000-0000-0000-000000000001",
    action: "patient.create",
    entityType: "Patient",
    entityId: "BN-0001",
    result: "SUCCESS",
    ip: "127.0.0.1",
    correlationId: null,
    before: null,
    after: null,
    actorName: null,
    actorRole: null,
  },
  // #19111 — một dòng CÓ ảnh chụp, để màn hình ở chế độ mock cũng mở ra được phần trước/sau.
  {
    id: "a-2",
    occurredAt: new Date().toISOString(),
    actorType: "USER",
    actorId: "00000000-0000-0000-0000-000000000001",
    action: "appointment.assign_doctor",
    entityType: "appointment",
    entityId: "00000000-0000-0000-0000-0000000000aa",
    result: "SUCCESS",
    ip: "127.0.0.1",
    correlationId: null,
    before: JSON.stringify({
      patientId: "00000000-0000-0000-0000-0000000000b1",
      departmentId: "00000000-0000-0000-0000-0000000000c1",
      doctorProfileId: "11111111-1111-4111-8111-111111111111",
      roomId: null,
      assignState: "PENDING_ROOM",
    }),
    after: JSON.stringify({
      patientId: "00000000-0000-0000-0000-0000000000b1",
      departmentId: "00000000-0000-0000-0000-0000000000c1",
      doctorProfileId: "22222222-2222-4222-8222-222222222222",
      roomId: "33333333-3333-4333-8333-333333333333",
      assignState: "ASSIGNED",
    }),
    actorName: "Minh",
    actorRole: "Chủ phòng khám",
  },
];

export const mockAudit = {
  async list(
    filter: AuditListFilter | undefined,
    pageable: { page?: number; size?: number }
  ): Promise<PageResponse<AuditLogEntry>> {
    let all = ROWS.slice();
    if (filter?.action) all = all.filter((r) => r.action === filter.action);
    if (filter?.entityType)
      all = all.filter((r) => r.entityType === filter.entityType);
    const size = pageable.size ?? 20;
    const page = pageable.page ?? 0;
    return delay({
      content: all.slice(page * size, page * size + size),
      totalElements: all.length,
      totalPages: Math.max(1, Math.ceil(all.length / size)),
      number: page,
      size,
    });
  },
};
